
import templatePostQuery from "~/apollo/queries/templates/post";
import templatePostsQuery from "~/apollo/queries/templates/posts";
import lenisScrollMixin from "@/mixins/lenisScrollMixin";
import previewModeMixin from "@/mixins/previewModeMixin";
import fetchPostMixin from "@/mixins/fetchPostMixin";
import seoMixin from "@/mixins/seoMixin";

export default {
  name: 'TemplatePostSlug',
  colorMode: 'light',
  mixins: [lenisScrollMixin, previewModeMixin, fetchPostMixin, seoMixin],
  async asyncData({app, route, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    // Fetch templatePost data
    const templatePostResponse = await app.apolloProvider.defaultClient.query({
      query: templatePostQuery,
      variables: {
        slug: route.params.slug,
        locale: app.i18n?.locale || 'en',
      },
    });

    const templatePost = templatePostResponse.data.templatePosts.data[0];

    // Set route parameters for localization
    app.store.dispatch(
      "i18n/setRouteParams",
      Object.fromEntries(
        templatePost.attributes.localizations.data.map((el) => [
          el.attributes.locale,
          {slug: el.attributes.slug},
        ])
      )
    );

    // Fetch relatedPosts data
    let relatedPostsResponse = await app.apolloProvider.defaultClient.query({
      query: templatePostsQuery,
      variables: {
        locale: app.i18n?.locale || 'en',
      },
    });

    const relatedPosts = relatedPostsResponse.data.templatePosts.data;

    // // Set route parameters for localization
    // app.store.dispatch(
    //   "i18n/setRouteParams",
    //   Object.fromEntries(
    //     templatePost.attributes.localizations.data.map((el) => [
    //       el.attributes.locale,
    //       {slug: el.attributes.slug},
    //     ])
    //   )
    // );

    return {
      templatePost,
      relatedPosts,
      previewMode
    }
  },
  data() {
    return {
      templatePost: null,
      relatedPosts: null,
      targetImgIndex: 0
    };
  },
  created() {
    const preview = this.$route.query.preview;

    if (preview && !this.templatePost) {
      // Set color as it doesn't automatically set after redirect
      this.$colorMode.preference = 'dark';
      this.fetchPost('templatePosts', templatePostQuery).then(templatePostData => {
        this.templatePost = templatePostData;

        this.fetchRelatedPosts(templatePostData.attributes.template_categories.data.map(tag => tag.attributes.title)).then(relatedPostsData => {
          this.relatedPosts = relatedPostsData;
          this.$nextTick(() => {
            this.previewMode = true;
          });
        });

        this.$nextTick(() => {
          this.previewMode = true;
        });
      });
    }
  },
  methods: {
    setTargetImage(index) {
      if (index >= 0 && index < this.templatePost.attributes.thumbnails.data.length) {
        this.targetImgIndex = index;
      }
    },
    getPageData() {
      return this.templatePost;
    },
  },
  beforeRouteLeave(to, from, next) {
    // Reset color as it doesn't automatically set after redirect (preview)
    this.$colorMode.preference = 'light';
    next()
  },
};
